import { gql, useQuery } from '@apollo/client'

import { AccountSettingsQuery } from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<AccountSettingsQuery>(QUERY)

  return {
    state: {
      isMembershipPersonalInformationRequired:
        !!data?.user?.isMembershipPersonalInformationRequired,
    },
    actions: {},
  }
})

const QUERY = gql`
  query AccountSettings {
    user {
      id
      isMembershipPersonalInformationRequired
    }
  }
`
